import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../Service/app-service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgxCaptchaModule } from 'ngx-captcha';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxCaptchaModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  captchaToken: string = '';
  siteKey = environment.siteKey;
  loginForm: any;
  errorMessage: string | null = null;
  showPassword: boolean = false;
  constructor(private fb: FormBuilder, private tosterService: ToastrService, private authService: AuthService, private SpinnerService: NgxSpinnerService, private router: Router) { }


  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [localStorage.getItem('rememberUsername') || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        )
      ]],
      password: [localStorage.getItem('rememberPassword') || '', Validators.required],
      rememberMe: [!!localStorage.getItem('rememberUsername')],
      recaptcha: ['', Validators.required]
    });
  }

  getImageUrl(): string {
    return environment.iamge
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  onSubmit(): void {
    this.SpinnerService.show();
    // Mark all fields as touched to show validation messages
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      if (this.loginForm.get('recaptcha')?.invalid) {
        this.tosterService.warning('Please verify the reCAPTCHA');
      }
      this.SpinnerService.hide();
      return;
    }

    const { email, password, rememberMe } = this.loginForm.value;
    this.authService.login({ email, password }).subscribe({
      next: (response) => {
        // Handle successful login
        sessionStorage.setItem('token', response.data.accessToken);
        sessionStorage.setItem('id', response.data.id);
        sessionStorage.setItem('userName', response.data.name);
        sessionStorage.setItem('useremail', response.data.email);

        if (rememberMe) {
          localStorage.setItem('rememberUsername', email);
          localStorage.setItem('rememberPassword', password);
        } else {
          localStorage.removeItem('rememberUsername');
          localStorage.removeItem('rememberPassword');
        }
        // this.showToast();
        // Navigate to the dashboard
        setTimeout(() => {
          this.router.navigate(['/home']);
          this.SpinnerService.hide();
          this.tosterService.success('Login Successfully');
        }, 3000);
      },
      error: (error) => {
        this.SpinnerService.hide();
        const message = error?.error?.data ? error.error.data : 'Server down or something went wrong. Please try again later.';
        this.tosterService.error(message);
        this.errorMessage = message;
        console.error('Login error:', error);
      }
    });
  }
  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }
  // showToast(): void {
  //   const toast = document.getElementById('customToast');
  //   if (toast) {
  //     toast.classList.add('show');
  //     setTimeout(() => {
  //       toast.classList.remove('show');
  //     }, 3000); // Hide after 3 seconds
  //   }
  // }

  handleReset() {
    console.log('reCAPTCHA reset:=>', 'reCAPTCHA reset');
    this.loginForm.patchValue({ recaptcha: null });
  }

  handleExpire() {
    console.log('reCAPTCHA expired:=>', 'reCAPTCHA expired');
    this.loginForm.patchValue({ recaptcha: null });
  }


  handleLoad() {
    console.log('reCAPTCHA loaded:=>', 'reCAPTCHA loaded');
  }

  handleSuccess(captchaResponse: string) {
    console.log('CAPTCHA success token:', captchaResponse);
    this.captchaToken = captchaResponse;
    this.loginForm.patchValue({ recaptcha: captchaResponse });
  }
}
